import React from 'react';
import renderHTML from 'react-render-html';
import { Link } from 'react-router-dom';

function PageList({ pages }) {
    return (
        <div>
            {pages.map((page) => (
                <article key={page.id} id={'page-' + page.id} className='page'>
                    <header className='entry-header'>
                        <h2 className='entry-title'>
                            <Link to={'/' + page.id}>{page.title.rendered}</Link>
                        </h2>
                    </header>
                    <div className='entry-content'>
                        {renderHTML(page.excerpt.rendered ? page.excerpt.rendered : "<p>No content Found</p>")}
                    </div>
                </article>
            ))}
        </div>
    );
}

export default PageList;
